module.exports = __webpack_public_path__ + "img/lineContact.75ec62c0.svg";